export default __webpack_public_path__ + "56375939fa540ce563d90b01f248b790.svg";